import { useUi } from '../../context/UiContext';
import { useI18n } from '../../i18n/useI18n';
import styles from './overlays.module.css';

const SHORTCUTS = [
  ['keys.next', 'Enter'],
  ['keys.delete', 'Backspace'],
  ['keys.move', '↑ ↓'],
  ['keys.reorder', 'Alt ↑ ↓'],
  ['keys.search', '/'],
  ['keys.today', 'T'],
  ['keys.day', '[ ]'],
  ['keys.prefs', '⌘ \\'],
  ['keys.close', 'Esc'],
];

export function ShortcutsDialog() {
  const { close } = useUi();
  const { t } = useI18n();

  return (
    <div className={styles.scrim} onClick={() => close('helpOpen')}>
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="shortcuts-title"
        onClick={(event) => event.stopPropagation()}
      >
        <p className={styles.kicker}>{t('keys.kicker')}</p>
        <h2 id="shortcuts-title">{t('keys.title')}</h2>
        <dl className={styles.shortcuts}>
          {SHORTCUTS.map(([label, keys]) => (
            <div key={label}>
              <dt>{t(label)}</dt>
              <dd>
                <kbd>{keys}</kbd>
              </dd>
            </div>
          ))}
        </dl>
        <div className={styles.modalActions}>
          <button type="button" className={styles.primary} onClick={() => close('helpOpen')}>
            {t('keys.done')}
          </button>
        </div>
      </div>
    </div>
  );
}
